/* eslint-disable @typescript-eslint/no-unused-vars */

import { MATCH_TYPES } from '../../../../app/constants/match_types';
import { updateComponent } from '../../../../app/package-designer/store/component.actions';

xplenty.directive('filterEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./filter-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        'ngrxStoreService',
        function ($scope, ngrxStoreService) {
          $scope.matchTypes = MATCH_TYPES;

          $scope.onRecordsChange = (records) => {
            $scope.component.predicates.expressions = records;
          };

          $scope.setMatchType = (match_type) => {
            ngrxStoreService.dispatch(updateComponent({ component: { predicates: { match_type } } }));
            $scope.component.predicates.match_type = match_type;
          };
        },
      ],
    };
  },
]);
